export default "__VITE_ASSET__CygCLvLD__"